import { useTexture } from '@react-three/drei'

export default function Walls()
{
    // const texture = useTexture('./textures/room/concrete_floor_painted/concrete_floor_painted_diff_1k.jpg')
    const texture = useTexture('./textures/room/rusty_metal_03/rusty_metal_03_diff_1k.jpg')
    // const texture = useTexture('./textures/room/white_rough_plaster/white_rough_plaster_diff_1k.jpg')

    const height = 4

    return <>

        {/* Walls Right */}
        <mesh 
            receiveShadow 
            position={[-2,height/2-2,0]}
            rotation-y={ Math.PI * 0.5 } 
        >
            <planeGeometry 
                args={[4,height]}
            />
            <meshStandardMaterial 
                map={texture}
            />
        </mesh>

        {/* Walls Right */}
        <mesh 
            receiveShadow 
            position={[0,height/2-2,-2]}
            >
            <planeGeometry 
                args={[4,height]}
            />
            <meshStandardMaterial 
                map={texture}
            />
        </mesh>
    </>   
}